export const new_mexico = {
  "35000": "New Mexico",
  "35001": "Bernalillo County",
  "35003": "Catron County",
  "35005": "Chaves County",
  "35006": "Cibola County",
  "35007": "Colfax County",
  "35009": "Curry County",
  "35011": "DeBaca County",
  "35013": "Dona Ana County",
  "35015": "Eddy County",
  "35017": "Grant County",
  "35019": "Guadalupe County",
  "35021": "Harding County",
  "35023": "Hidalgo County",
  "35025": "Lea County",
  "35027": "Lincoln County",
  "35028": "Los Alamos County",
  "35029": "Luna County",
  "35031": "McKinley County",
  "35033": "Mora County",
  "35035": "Otero County",
  "35037": "Quay County",
  "35039": "Rio Arriba County",
  "35041": "Roosevelt County",
  "35043": "Sandoval County",
  "35045": "San Juan County",
  "35047": "San Miguel County",
  "35049": "Santa Fe County",
  "35051": "Sierra County",
  "35053": "Socorro County",
  "35055": "Taos County",
  "35057": "Torrance County",
  "35059": "Union County",
  "35061": "Valencia County",
};
